import { MarketSegmentedControl, MarketShowDeclinedToggle } from '~/features/shared/market-content';
import { ResponsiveFilters } from '~/features/shared/market-content/ResponsiveFilters';

type Props<TFilter extends string> = {
  options: Array<{ label: string; value: TFilter; cyTag?: string }>;
  filter: TFilter;
  onFilter: (filter: TFilter) => void;
  /** [MCV-1850] Declined and withdrawn responses are hidden unless this is set. */
  includeDeclined?: boolean;
  onIncludeDeclined?: (includeDeclined: boolean) => void;
  /** [MCV-1889] Below 1360px the filters collapse into a "Filters (N)" drawer. */
  responsive?: boolean;
};

/**
 * The status tabs and "Show declined" toggle that head a list of responses, and the drawer they
 * collapse into on narrow screens. Shared by the Sent list and the Received list.
 */
export const OpportunityFilters = <TFilter extends string>({
  options,
  filter,
  onFilter,
  includeDeclined = false,
  onIncludeDeclined,
  responsive = false,
}: Props<TFilter>) => {
  const controls = (
    <>
      <MarketSegmentedControl
        className="w-full"
        fullWidth
        options={options}
        value={filter}
        onChange={onFilter}
      />
      {onIncludeDeclined && (
        <MarketShowDeclinedToggle
          className="mt-2"
          checked={includeDeclined}
          onChange={onIncludeDeclined}
        />
      )}
    </>
  );
  return (
    <div className="mt-3">
      {responsive ? (
        // The count is how many of the two controls are off their defaults.
        <ResponsiveFilters count={(filter !== 'all' ? 1 : 0) + (includeDeclined ? 1 : 0)}>
          {controls}
        </ResponsiveFilters>
      ) : (
        controls
      )}
    </div>
  );
};
